import { withDevtools, withStorageSync } from '@angular-architects/ngrx-toolkit';
import { ENHANCEMENT_EFFECTS } from '@app/store/data/enhancement/enhancement.effects';
import { ENHANCEMENT_METHODS } from '@app/store/data/enhancement/enhancement.methods';
import { ENHANCEMENT_SELECTORS } from '@app/store/data/enhancement/enhancement.selectors';
import type { EnhancementEntity, EnhancementState } from '@app/store/data/enhancement/enhancement.types';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { withEffects } from '@ngrx/signals/events';
import App from '@app/app';
import { downgradeInjectable } from '@angular/upgrade/static';

const initialState: EnhancementState = { templateMap: {} };

export const EnhancementStore = signalStore(
  { providedIn: 'root' },
  withDevtools('mlt.data.enhancementStore'),
  withStorageSync('mlt.data.enhancementStore'),
  withState<EnhancementState>(initialState),
  withMethods(ENHANCEMENT_METHODS),
  withEntities<EnhancementEntity>(),
  withComputed(ENHANCEMENT_SELECTORS),
  withEffects(ENHANCEMENT_EFFECTS)
);

App.factory('EnhancementStore', downgradeInjectable(EnhancementStore));
